import logo from './images/logo_header.svg';
import avatar from "./images/avatar.svg";
import {
	MESSAGE_NO_AGENTS_AVAILABLE_DEFAULT, MESSAGE_NO_AGENTS_AVAILABLE_ESTIMATES,
	MESSAGE_STANDARD_INFO,
	MESSAGE_STANDARD_INFO_ESTIMATES,
	QUEUE_NAME_SCRIPPS_1_800,
	QUEUE_NAME_SCRIPPS_ESTIMATES
} from "./constants";

export const config = {
	isStandalone: true,
	apiKey: "6eb3054b-d56f-4363-9f96-d798a2064f14",
	messages: {
		//firstStartMessage: [{title: MESSAGE_STANDARD_INFO}],
		//secondStartMessage: [],
		// waitingAgentEventMessage: '',
		// cancelLiveChatMessage: {title: '', buttons: []},
	},
	chatLogo: logo,
	avatarUrl: avatar,
	enableFeedbackForAllAgents: true,
	hooks: {
		/** @Function: getFirstStartMessages
		 *  @Return: array => [{title: 'text'}, ...]
		 */
		getFirstStartMessages: (props) => {
			// return empty
		},

		/** @Function: getSecondStartMessages
		 *  @Return: array => [{title: 'text'}, ...]
		 */
		getSecondStartMessages: (props) => {
			switch (props.startQueueName){
				case QUEUE_NAME_SCRIPPS_ESTIMATES:
					return [{title: MESSAGE_STANDARD_INFO_ESTIMATES}];
				default:
					return [{title: MESSAGE_STANDARD_INFO}];
			}
		},

		/** @Function: getQueueType
		 *  @Return: integer
		 */
		// getQueueType: (props) => {},

		/** @Function: getWaitingAgentEventMessage
		 *  @Return: string
		 */
		getWaitingAgentEventMessage: (props) => {
			switch (props.currentQueueName) {
				case QUEUE_NAME_SCRIPPS_ESTIMATES:
					return MESSAGE_NO_AGENTS_AVAILABLE_ESTIMATES;
				default:
					return MESSAGE_NO_AGENTS_AVAILABLE_DEFAULT;
			}

		},

		/** @Function: getMessageAgentConnected
		 *  @Return: string
		 */
		getMessageAgentConnected: () => {
			// return empty
		},

		/** @Function: getMessageAfterAgentConnected
		 *  @Return: string
		 */
		getMessageAfterAgentConnected: (agentName, currentQueueName) => {
			switch (currentQueueName) {
				case QUEUE_NAME_SCRIPPS_1_800:
					return 'Hello, my name is ' + agentName + '. I am a Health Resource Coordinator ' +
						' at Scripps Health. How can I help you today?';
				case QUEUE_NAME_SCRIPPS_ESTIMATES:
					return 'Hi, my name is ' + agentName + '. I am a Patient Service Specialist ' +
						'on the Estimate team at Scripps Health. How can I help you?';
				default:
					return 'Hi, my name is ' + agentName + ', how can I help you?';
			}
		},
	}
};
